<template lang="pug">
    .component-confirm-dialog
        .reveal(:id="id").small
            h2   {{title}}
            p.lead   {{message}}
            .content
                slot
            button.button.success.yes(data-close='', v-on:click="successClick") Yes
            button.button.alert.float-right(data-close='') No
</template>
<script type="text/babel">
    export default{
        name: "ConfirmDialog",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {
            successClick(){
                this.$emit('successClicked')
            }
        },
        props: ['title', 'message', 'formData', 'id']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// ConfirmDialog.vue?739dca22